module.exports = __webpack_public_path__ + "static/media/arrow_right_black.9fffa6a3.svg";